export default "__VITE_ASSET__DuQvLshC__"